import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';

import { password } from '@adflow/shared/util-superstruct';

export const ResetPasswordDto = object({
	token: string(),
	newPassword: password(),
});
export type ResetPasswordDto = Infer<typeof ResetPasswordDto>;
